import React from 'react';
import styles from '../../../assets/css/vendors/steps_vendor.module.css';
import CardPeoples from '../../../components/cards/CardPeoples';
import images from '../../../assets/images';
import { useNavigate } from 'react-router-dom';

function ProviderDirectory() {
    const navigation = useNavigate();
    const data = [
        {
            image: images.campfireSocialLogo,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.notUser,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.userTest,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.profile,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        },
        {
            image: images.openVendorOffers,
            name: 'Highland',
            occupation: '15 followers'
        }
    ];
    return (
        <>
            <div className={`${styles.cardMainContent}`}>
                <div className={`${styles.rows} ${styles.text_center}`}>
                    <div className={styles.algo}>
                        <img
                            src={images.imgx}
                            alt="Icon"
                            className={styles.icon}
                        />
                    </div>
                    <p className={styles.green_p}>Explore Providers</p>
                </div>
                <div className={styles.gridContainer}>
                    {data.map((val, key) => {
                        return (
                            <CardPeoples
                                image={val.image}
                                name={val.name}
                                ocupation={val.occupation}
                                key={key}
                                onClick={() =>
                                    key === 4
                                        ? navigation('/vendor')
                                        : navigation('/warning-vendor')
                                }
                            />
                        );
                    })}
                </div>
            </div>
        </>
    );
}
export default ProviderDirectory;
